
import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    root: {},
    hint: {
      color: '#3f505a',
      fontSize: 14,
      fontWeight: 'normal',
      marginBottom: theme.spacing(2),
    },
    progress: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    captcha: {
      maxHeight: 60,
      maxWidth: '100%',
      borderRadius: 4,
      marginInlineStart: theme.spacing(1),
      marginTop: theme.spacing(3),
    },
    submitContainer: {
      paddingTop: theme.spacing(2),
      // borderTop: `1px solid ${theme.palette.grey[300]}`
    },
  }));